     <div class="container"> 
        <div class="home_custom_css" style="height: 850px;"> 
           
          </div>
        </div>
